import { AbilityBuilder, createMongoAbility } from "@casl/ability";
const { can, build, cannot } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
  if (user && user.temPermissao(["cliente"])) {
    if (user.temPermissao(["projetista", "site_manager"])) {
      can(["read"], ["PROJETO", "Obra"]);
      can(["comentario"], ["PROJETO"]);
    }
    if (user.temPermissao(["projetista_fabrica"])) {
      can(["read"], ["PROJETO_FABRICA", "FABRICACAO", "Produto"]);
      can(["comentario"], ["PROJETO"]);
    }
    if (user.temPermissao(["aprovador", "aprovador_fabrica"])) {
      can(["update", "read"], "PROJETO", {
        Situacao: { $in: ["PAP", "APC", "AP", "PR"] },
      });
      can(["read"], ["PROJETO_FABRICA", "FABRICACAO", "Produto"]);
    }

    
    can("read", "Obra", {
      Id_Lista: { $in: user.obra },
    });
  } else if (user) {
    can("read", "BIBLIOTECA");
    can("read", "PERFIL");
  }

  return build();
}
